var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white flex mdmax:flex-col"
  }, [_c('div', {
    staticClass: "p-6 flex-1 shadow-border-r mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Kategori Barang")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("ID")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.goodsCategoryDetail.code))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama Kategori")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.goodsCategoryDetail.name))])]), _c('div', {}, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Deskripsi")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.goodsCategoryDetail.category_description || '-'))])])]), _c('div', {
    staticClass: "p-6 flex-1 mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Sub Kategori")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Terdapat Sub Kategori")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.goodsCategoryDetail.sub_category_code ? 'Ya' : 'Tidak'))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama Sub Kategori")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.goodsCategoryDetail.sub_category_name || '-'))])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }